export default __webpack_public_path__ + "static/media/abid.1f86aead.JPG";